import React, { FunctionComponent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CardItemProps,
  DeleteUserObj,
  UpdateUserObj,
} from "../../../shared/interfaces/components/card.interface";
import { User } from "../../../shared/interfaces/model/user.interface";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import Modal from "../../../shared/components/modal/modal";
import * as actions from "../../../store/addTenantUser/actions";
import {
  deleteUserRowRequest,
  updateUserRowRequest,
  getTenantUserListRequest,
} from "../../../store/tenantUserList/action";

const warningString = "Non è possibile aggiornare perché ";

let responseCode = 0;
let responseData = "";

export const recoverResponseCode = async (code: number) => {
  responseCode = code;
};

export const recoverResponseData = async (message: string) => {
  responseData = message;
};

const Card: FunctionComponent<CardItemProps> = ({
  tenantDocId,
  displayName,
  userList,
  id,
  organizationEmail,
  tenantProducts,
  testProducts,
}: CardItemProps) => {
  // dispatch an action
  const dispatch = useDispatch();
  // reducer data
  const { tenantid, numEmployees, usersTenant, deleteUserRes } = useSelector(
    (state: any) => ({
      tenantid: state.tenantsReducer.detailsTenant.tenantId,
      numEmployees: state.tenantsReducer.detailsTenant.numberEmployees,
      usersTenant: state.tenantUserListReducer.tenantsUserList.users.length,
      deleteUserRes: state.tenantUserListReducer.deleteUserRes,
    })
  );

  // hooks
  const [show, setShow] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [showOps, setShowOps] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [oldEmail, setOldEmail] = React.useState("");
  const [threshold, setThreshold] = React.useState(false);
  const [alreadyExist, setAlreadyExist] = React.useState(false);
  const [currentUid, setCurrentUid] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [showModalOps, setShowModalOps] = React.useState(false);
  const [messageWarning, setMessageWarning] = React.useState(warningString);
  const [name, setName] = React.useState("");
  const [surname, setSurname] = React.useState("");
  const [selectedProducts, setSelectedProducts] = React.useState<string[]>([]);
  const [errorMessage, setErrorMessage] = React.useState("");

  // change hook state to open modal
  const showModal = (but: number) => {
    if (but === 1) setShow(true);
    if (but === 2) setShowUpdate(true);
    if (but === 3) setShowDelete(true);
    if (but === 4) setShowOps(true);
  };

  const hideModal = () => {
    setShow(false);
    setShowDelete(false);
    setShowUpdate(false);
    setShowOps(false);
  };

  // useEffect
  useEffect(() => {
    const regex = /[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/;
    if (numEmployees > usersTenant) setThreshold(true);
    const emailList = userList.map((us) => us.email);
    // if (email === "") setAlreadyExist(true); // to delete
    for (let i = 0; i < emailList.length; i += 1) {
      if (emailList[i] === email) {
        let m = warningString;
        m += "la mail: ";
        m += email;
        m += " esiste già!!!";
        setMessageWarning(m);
        setAlreadyExist(true);
      }
    }
    if (!regex.test(email)) {
      let m = warningString;
      m += "il formato inserito per la mail non è coretto!!!";
      setMessageWarning(m);
      setAlreadyExist(true);
    }

    /* if (responseCode !== 0 && responseData !== "" && showModalOps && !loading) {
      showModal(4);
    } */
    if (showModalOps && !loading) {
      if (responseCode === 0) responseCode = 500; // temporany
      if (responseData === "") responseData = "ServerError"; // temporany
      showModal(4);
    }
  }, [
    numEmployees,
    usersTenant,
    email,
    alreadyExist,
    userList,
    deleteUserRes,
    showModalOps,
    loading,
    name,
    surname,
  ]);

  const handleProductChange = (productId: string) => {
    setSelectedProducts((prevSelected) => {
      const updatedSelected = prevSelected.includes(productId)
        ? prevSelected.filter((id) => id !== productId)
        : [...prevSelected, productId];
      setSelectedProducts(updatedSelected);
      return updatedSelected;
    });
  };

  const emailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setAlreadyExist(false);
    setEmail(data.target.value);
  };

  const nameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setName(data.target.value);
  };

  const surnameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setSurname(data.target.value);
  };
  const emailChange2 = (s: string) => {
    setAlreadyExist(false);
    setEmail(s);
  };

  const fetchData = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };

  const sendData = () => {
    const payload = {
      tenantId: tenantid,
      userEmail: email,
      products: tenantProducts,
      testProducts: selectedProducts,
      name,
      surname,
    };
    dispatch(actions.postAddTenantUserRequest(payload));
  };

  const deleteUserRow = (deleteUserObj: DeleteUserObj) => {
    dispatch(deleteUserRowRequest(deleteUserObj));
  };

  const updateUserRow = (updateUserObj: UpdateUserObj) => {
    dispatch(updateUserRowRequest(updateUserObj));
  };

  return (
    <div className="card box" data-test="card-wrapper">
      <div className="card__header row col-md-12">
        <div className="col-xs-9 col-md-8 col-sm-9">
          <h3 className="card__header--title">{displayName}</h3>
        </div>
        <div className="card__header--button col-xs-3 col-md-3 col-sm-3">
          {/* TODO optimize disabled prop */}
          <button
            style={{
              backgroundColor: '#007bff', // Colore blu
              color: '#ffffff', // Colore del testo
              border: 'none', // Nessun bordo
              borderRadius: '5px', // Bordo arrotondato
              padding: '10px 20px', // Spaziatura interna
              cursor: 'pointer', // Cursore a mano
              fontSize: '16px', // Dimensione del font
              transition: 'background-color 0.3s', // Transizione per il colore di sfondo
            }}
            // disabled={threshold ? false : true}
            disabled={false}
            onClick={() => {
              emailChange2("");
              showModal(1);
              setAlreadyExist(false);
            }}
          >
            Invita membro
          </button>
        </div>
        <div data-test="showModal">
          {show && (
            <Modal handleClose={hideModal}>
              <div className="col-xs-8 row">
                <InputFieldComponent
                  placeholder="Scrivi email..."
                  name="email"
                  id="signin-email"
                  type="text"
                  label="User Email:"
                  value={email}
                  title="Inserire campo"
                  required
                  onChangeHandler={emailChange}
                />
              </div>
              <div className="col-xs-8 row">
                <InputFieldComponent
                  placeholder="Cognome"
                  name="surname"
                  id="signin-surname"
                  type="text"
                  label="Cognome:"
                  value={surname}
                  title="Inserire campo"
                  required
                  onChangeHandler={surnameChange}
                />
              </div>
              <div className="col-xs-8 row">
                <InputFieldComponent
                  placeholder="Nome"
                  name="name"
                  id="signin-name"
                  type="text"
                  label="Nome:"
                  value={name}
                  title="Inserire campo"
                  required
                  onChangeHandler={nameChange}
                />
              </div>
              <h5>Seleziona Prodotti:</h5>
              <div className="product-checkboxes">
                {testProducts?.filter((p) => p.tier === "Enterprise").map((product) => (
                  <div key={product.productAppName}>
                    <input
                      type="checkbox"
                      value={product.productAppName}
                      checked={selectedProducts.includes(product.productAppName)}
                      onChange={() => handleProductChange(product.productAppName)}
                    />
                    {`  ${product.productAppName}`}
                  </div>
                ))}
              </div>
              <h5>{alreadyExist ? "Attenzione:" : null}</h5>
              <h6>{alreadyExist ? messageWarning : null}</h6>
              <div className="col-xs-3">
                <Button
                  title={!loading ? "Aggiungi utente" : "Creazione Utente"}
                  disabled={alreadyExist || loading}
                  onClickHandler={() => {
                    fetchData();
                    sendData();
                    setShowModalOps(true);
                  }}
                />
                {loading && <i className="fa fa-refresh fa-spin" />}
              </div>
            </Modal>
          )}
        </div>
      </div>
      <ul className="list-group col-md-12">
        {userList.length > 0 &&
          userList.map((users: User) => (
            <li
              key={users.uid}
              className="list-group-item col-md-12"
              data-test="userList"
            >
              <div className="d-flex align-items-center col-md-7 col-sm-7">
                <div className="flex-shrink-0 col-md-1 col-sm-1">
                  <i className="fa-solid fa-circle-user avatar-xs roundend-circle" />
                </div>
                <div className="flex-grow-1 ms-2 col-md-11 col-sm-11">{users.email}</div>
              </div>

              <div className="button-custom col-md-2.5 col-sm-2.5">
                <Button
                  title="Aggiorna"
                  disabled={users.email === organizationEmail}
                  onClickHandler={() => {
                    setCurrentUid(users.uid);
                    setOldEmail(users.email);
                    emailChange2(users.email);
                    showModal(2);
                  }}
                />
              </div>

              <div className="button-custom col-md-2.5 col-sm-2.5">
                <Button
                  title="Elimina"
                  disabled={users.email === organizationEmail}
                  onClickHandler={() => {
                    setCurrentUid(users.uid);
                    emailChange2(users.email);
                    showModal(3);
                  }}
                />
              </div>

              {showUpdate && (
                <Modal handleClose={hideModal}>
                  <div>
                    <h3>Aggiorna questo Utente:</h3>
                    <div className="col-xs-8 row">
                      <InputFieldComponent
                        placeholder="Aggiorna Email dell'Utente..."
                        name="email"
                        id="signin-email"
                        type="text"
                        label="Email da aggiornare:"
                        value={email}
                        title="Inserire campo"
                        required
                        onChangeHandler={emailChange}
                      />
                    </div>
                    <h5>{alreadyExist ? "Attenzione:" : null}</h5>
                    <h6>{alreadyExist ? messageWarning : null}</h6>
                    <div className="row">
                      <div className="col-xs-6">
                        <Button
                          disabled={alreadyExist || loading}
                          title={!loading ? "Aggiorna" : "Aggiornamento Utente"}
                          onClickHandler={() => {
                            fetchData();
                            const updateUserObj = {
                              tenantId: tenantDocId,
                              usermail: oldEmail,
                              newMail: email,
                            };
                            updateUserRow(updateUserObj);
                            setShowModalOps(true);
                          }}
                        />
                        {loading && <i className="fa fa-refresh fa-spin" />}
                      </div>
                      <div className="col-xs-6">
                        <Button title="Elimina" onClickHandler={hideModal} />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
              {showDelete && (
                <Modal handleClose={hideModal}>
                  <div>
                    <h3 className="text-align-center">
                      E&#39; sicuro di voler eliminare l&#39;utente<br />
                      <q>{email}</q> ?
                    </h3>
                    <div className="row">
                      <div className="col-xs-6">
                        <Button
                          title={!loading ? "Si" : "Cancellazione Utente"}
                          disabled={loading}
                          onClickHandler={() => {
                            fetchData();
                            const deleteUserObj = {
                              tenantId: tenantDocId,
                              usermail: email,
                            };
                            deleteUserRow(deleteUserObj);
                            setShowModalOps(true);
                          }}
                        />
                        {loading && <i className="fa fa-refresh fa-spin" />}
                      </div>
                      <div className="col-xs-6">
                        <Button title="No" onClickHandler={hideModal} />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}
              {showOps && (
                <Modal handleClose={hideModal}>
                  <div>
                    <h3>
                      Operazione
                      {responseCode >= 200 && responseCode < 300
                        ? " Eseguita !"
                        : " Fallita !"}
                    </h3>
                    <h4>{responseData}</h4>
                    <div className="row">
                      <div className="col-xs-4"> </div>
                      <div className="col-xs-4">
                        <Button
                          title="Ok"
                          onClickHandler={() => {
                            responseCode = 0;
                            responseData = "";
                            setShowModalOps(false);
                            hideModal();
                            // window.location.reload();
                          }}
                        />
                      </div>
                      <div className="col-xs-4"> </div>
                    </div>
                  </div>
                </Modal>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Card;
